import { EntityState } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AttendanceRecord } from 'app/models';
import { attendanceAdapter } from './attendance.reducers';

export type AttendanceRecordState = EntityState<AttendanceRecord>;

export const selectAttendanceState = createFeatureSelector<AttendanceRecordState>('attendance');

const { selectAll } = attendanceAdapter.getSelectors();

export const getAttendanceForInstance = (id: number) =>
	createSelector(selectAll, (entities) => {
		return entities.filter((record) => record.activity_instance_id === id);
	});

export const getAttendanceForInstanceAndUser = (instance_id: number, user_id: number) =>
	createSelector(selectAll, (entities) => {
		return entities.filter((record) => record.activity_instance_id === instance_id && record.attendance_user.id == user_id)[0];
	});
